import { makeAutoObservable } from 'mobx'
import * as API from '../../../service/api/AccountManage/InstitutionApi'
import table from '../../commons/table'

class InstitutionStore {
  constructor() {
    makeAutoObservable(this)
  }

  table = new table(API.GET_ORG_LIST)

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  addOrg = async (data) => {
    return await API.ADD_ORG(data)
  }

  delOrg = async (data) => {
    return await API.DEL_ORG(data)
  }
}

export default new InstitutionStore()
